export default __webpack_public_path__ + "static/media/money.a8f0575b.svg";